import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Container, Grid, GridColumn, Icon, Button} from "semantic-ui-react";
import MobileTips from "./common/MobileTips";
import * as locationActions from "../store/location/locationActions";

class OpenCalls extends PureComponent {
  static propTypes = {
    show: PropTypes.object.isRequired,
    season: PropTypes.object.isRequired,
    page: PropTypes.object.isRequired,
    location: PropTypes.array.isRequired,
  };

  static defaultProps = {
    page: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.page && this.props.page.externalIdC) {
      this.props.getLocations(this.props.page.externalIdC);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.page &&
      this.props.page.externalIdC &&
      prevProps.page.externalIdC !== this.props.page.externalIdC
    ) {
      this.props.getLocations(this.props.page.externalIdC);
    }
  }

  toggleVisibility = () => this.setState({ visible: !this.state.visible });

  closeMenu = () => this.setState({ visible: false });

  renderTips(tips) {
    return (
      <GridColumn className="ui sixteen wide mobile five wide computer right floated tablet-up">
        <div className="ui fluid card noShadow tip">
          <div
            className="content invertedPrimary"
            style={{ backgroundColor: `#${this.props.season.hexColorCodeC}` }}
          >
            <div className="header">
              <h4>Tip</h4>
            </div>
          </div>
          <div
            className="content shaded padded"
            dangerouslySetInnerHTML={{ __html: tips }}
          />
        </div>
      </GridColumn>
    );
  }

  renderLocations(locations){
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    let locationList = [];
    for (let location of locations) {
      let date = new Date(location.dateC);

      // Set date
      let dateString = '';
      dateString += days[date.getUTCDay()] + ', ';
      dateString += monthNames[date.getUTCMonth()] + ' ';

      //set from time
      let frommins = location.fromC.substr(location.fromC.indexOf(":"), 3);
      let fromTime = location.fromC.substring(0, 2);
      let dd = "AM";
      if (fromTime >= 12) {
        fromTime = parseInt(location.fromC, 10) - 12;
        dd = "PM";
      }
      if (fromTime === 0) {
        fromTime = 12;
      }
      let from = fromTime + frommins + dd;

      // set to time
      let tommins = location.toC.substr(location.toC.indexOf(":"), 3);
      let toTime = location.toC.substring(0, 2);
      dd = "AM";
      if (toTime >= 12) {
        toTime = parseInt(location.toC, 10) - 12;
        dd = "PM";
      }
      if (toTime === 0) {
        toTime = 12;
      }
      let to = toTime + tommins + dd;

      dateString += date.getUTCDate() + ' / ' + from + ' - ' + to;

      locationList.push(
        <div className="location" key={location.id}>
          <h2 style={{ color: `#${this.props.season.hexColorCodeC}` }}>
            {location.cityC}, {location.stateC}
          </h2>
          <h4>{dateString}</h4>
          <div className="locationDescription">
            <p>
              <strong style={{ color: `#${this.props.season.hexColorCodeC}` }}>
                {location.name}
              </strong>
              <br />
              {location.streetNameC}
              <br />
              {location.cityC}, {location.stateC}{' '}
              {location.zipCodeC}
            </p>
            <p>
              <strong style={{ color: `#${this.props.season.hexColorCodeC}` }}>
                {location.contactC}
              </strong>
              <br />
              {location.moreInformationC}
            </p>
          </div>
        </div>
      );
    }
    return locationList;
  }

  fixPageContent(pageContent) {
    pageContent = pageContent.split("target=\"_blank\"");

    for (let content in pageContent) {
      if (pageContent.length !== parseInt(content) + 1 && !pageContent[content].includes("mailto:")) {
        pageContent[content] += "target=\"_blank\"";
      }
    }

    return pageContent.join();
  }

  render() {
    const { show, page, season } = this.props;
    const tips = page && page.tipsC ? this.renderTips(page.tipsC) : '';
    let pageContent = '';
    if (page && page.pageContentC) {
      pageContent = this.fixPageContent(page.pageContentC);
    }

    if (page) {
      return (
        <div>
          <Container id="mainContent" className="ui">
            <Grid className="ui">
              <GridColumn className="pageShowTitle">
                <h3
                  className="ui dividing header"
                  style={{ color: `#${season.hexColorCodeC}` }}
                >
                  {show.name} Casting
                </h3>
                <Button
                  onClick={this.toggleVisibility}
                  id="applyToggle"
                  className="tiny ui primary tablet-down mobileToggle"
                >
                  <Icon className="sidebar" />
                  Tips
                </Button>
              </GridColumn>
            </Grid>

            <MobileTips
              tips={page.tipsC}
              hexColorCodeC={season.hexColorCodeC}
              visible={this.state.visible}
              toggleVisibility={this.toggleVisibility}
            />

            <Grid className="ui stackable" onClick={this.closeMenu}>
              <GridColumn className="ui sixteen wide mobile eight wide computer">
                <h1>{page.pageTitleC}</h1>

                <p className="lead">{page.leadParagraphC}</p>

                <style>{"\
                .inner-html a {\
                  color:#" + season.hexColorCodeC + " !important;\
                }\
              "}</style>

                <div className="inner-html" dangerouslySetInnerHTML={{ __html: pageContent}} />

                <div className="ui hidden padded divider" />

                <div className="castingLocations">
                  {this.renderLocations(this.props.location)}
                </div>

              </GridColumn>

              {tips}
            </Grid>
          </Container>
        </div>
      );
    }
    return <div />;
  }
}

const mapStatesToProps = state => ({
  location: state.location.location,
  loading: state.location.loading,
});

const mapDispatchToProps = dispatch => ({
  getLocations: pageId => dispatch(locationActions.getLocations(pageId)),
});

export default connect(mapStatesToProps, mapDispatchToProps)(OpenCalls);



// WEBPACK FOOTER //
// ./src/components/OpenCalls.js